export class OrderStatus {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}
